import {Typography} from "@mui/material";

export const CdpvfInfoContent = (selectorContractGridAPI) => {


    switch(selectorContractGridAPI) {

        case 'Dashboard':
            return {
                title: 'Returned Data Points',
                content: 'Select the Data Points that you want to see on the Dashboard.  ' +
                    'Choose the order in which they will display.'
            };

        default:
            // case 'Drilldown':
            return {
                title: 'Contract Data Point Value Filters',
                    content: (
                        <>
                            <Typography paragraph>
                                Contract Data Point Value Filters are a simpler version of
                                Contract Section Filters.
                            </Typography>

                            <ul>
                                <li>
                                    They determine whether a Contract Data Point Value
                                    will be added to an individual Contract Model.
                                </li>

                                <li>
                                    Matching is performed by comparing their Data Point
                                    to the Data Point of that individual Contract Model.
                                </li>

                                <li>
                                    Filters can be nested and branched.
                                </li>

                                <li>
                                    All filters in a Path must match.
                                </li>

                                <li>
                                    All matches are positive (Allow).
                                </li>

                                <li>
                                    Contract Data Point Values can only be assigned
                                    to the terminal Contract Data Point Value Filter
                                    of any Path.
                                </li>
                            </ul>
                        </>
                    )
                //
                //
                // content: 'Contract Data Point Value Filters are a simpler version of Contract Section Filters.  ' +
                //     'They determine whether a Contract Data Point Value will be added to an individual Contract Model ' +
                //     'by matching their Data Point to the Data Point of that individual Contract Model. ' +
                //     'They can be nested and branched, all filters in a Path must match, and all matches are positive (Allow).  ' +
                //     'Contract Data Point Values can only be assigned to the terminal Contract Data Point Value Filter of any Path.'
            };

    }

};